module.exports = __webpack_public_path__ + "img/logo_w.05beda72.png";